<template>
    <div class="mask-layer mask">
        <div class="container">
            <div class="title">
                发送文书
            </div>
            <div class="content">
                <div class="form_item">
                    <div class="form_left mln12">
                        <p><i class="required">*</i>手机号码：</p>
                    </div>
                    <div class="form_right">
                        <el-input class="el_box" type="text" placeholder="请输入手机号码" v-model.trim="model.phone"></el-input>
                    </div>
                </div>
                <!-- <div class="form_item">
                    <div class="form_left mln12">
                        <p>短信模版：</p>
                    </div>
                    <div class="form_right textarea h100">
                        <el-input disabled type="textarea" placeholder="请输入短信模版" v-model="model.remark" name="remark" maxlength="130" show-word-limit></el-input>
                    </div>
                </div> -->
            </div>
            <div class="btn-wrap">
                <button type="button" class="btn mr20" @click="send">发送</button>
                <button type="button" class="btn" @click="close">取消</button>
            </div>
            <div class="close" @click="close">X</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "send",
    props: ['sendPhoneStr', 'id'],
    data() {
        return {
            model: {
                phone: '',
                remark: '', //备注
            },
            
        }
    },
    created() {
        this.model.phone = this.sendPhoneStr;
    },
    mounted() {
        // this.getContent(); //获取文书内容
    },
    computed: {

    },
    methods: {
        send() {
            let accidentId = this.id;
            let phone = this.model.phone;
            if(phone == null || phone == "") {
                return this.$message.error("请输入手机号码");
            }
            this.$axios.post(`/admin/enforcement/send/${accidentId}/clerical`, {
                phone
            }).then(res => {
                let data = res.data;
                if (data.code === 0) {
                    this.$message.success('发送成功');
                    this.$emit('hideSend');
                } else {
                    this.$message.error(data.msg);
                }
            })
        },
        getContent() {
            var accidentId = this.id;
            this.$axios.post(`/admin/accident/${accidentId}/file/viewMsgContent`).then(res => {
                let data = res.data;
                if (data.code === 0) {
                    this.model.remark = data.data.msgContent;
                } else {
                    this.$message.error(data.msg);
                }
            })
        },
        close() {
            this.$emit('hideSend');
        },
        
    }
}
</script>

<style lang="scss" scoped>
.mask-layer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.form_item {
    display: flex;
    justify-content: center;
}

.form_left {
    line-height: 32px;
    margin-right: 10px;
}

.form_right {
    line-height: 32px;
    width: 200px !important;
    box-sizing: border-box;
    padding-left: 10px;
    text-align: left;
    height: 45px;
}

.container {
    background-color: #fff;
    width: 600px;
    box-sizing: border-box;
    padding-bottom: 10px;
    max-height: 650px;
    position: relative;
    overflow-y: scroll;

    .close {
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 14px;
        position: absolute;
        top: 10px;
        right: 5px;
        cursor: pointer;
    }

    .title {
        height: 41px;
        line-height: 41px;
        box-sizing: border-box;
        padding-left: 16px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #4A4A4A;
        text-align: left;
        border-bottom: 1px solid #ECF1F4;
    }

    .content {
        padding: 16px;
        box-sizing: border-box;
    }
}
</style>



// WEBPACK FOOTER //
// send.vue?07899956